import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { get, trimEnd } from 'lodash';
import { FormattedMessage } from 'react-intl';
import qs from 'qs';

import '../css/top-nav-bar.css';
import pbgLogoBlue from '../img/keytravel-logo-blue.png';

class TopNavBar extends Component {
  constructor(props) {
    super(props);
    this.onLoginClick = this.onLoginClick.bind(this);
  }

  onLoginClick() {
    if (this.props.signinPage) {
      const query = qs.parse(this.props.location.search.substring(1));
      if (query.redirect) {
        return <Redirect to={`/login/?redirect=${query.redirect}`} />;
      }

      return <Redirect to="/login" />
    }

    window.$('#signin').modal('show');
  }

  get helpMenu() {
    let supportUrl = get(this.props, 'merchant.supportUrl');
    const isCustomUrl = supportUrl && supportUrl.length;
    const btnClass = 'btn btn-link nav-link dropdown-toggle top-nav-bar-help cool-grey';
    const helpCenterUrl = isCustomUrl ? trimEnd(supportUrl, '/') : 'https://paybygroup.zendesk.com/hc';
    return (
      <li className="nav-item dropdown ">
        <button type="button" className={btnClass} data-toggle="dropdown">
          <FormattedMessage
            id="topNavBar.helpMenu.help"
            defaultMessage="Help"
          />
          {' '}
          <i className="fa fa-question-circle-o fa-fw" aria-hidden="true" />
        </button>
        <div className="dropdown-menu dropdown-menu-right">
          <a
            className="dropdown-item my-2"
            href={helpCenterUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            {
              isCustomUrl ? (
                <FormattedMessage
                  id="topNavBar.helpCenter.custom"
                  defaultMessage="Help Center"
                />
              ) : (
                  <FormattedMessage
                    id="topNavBar.helpCenter.link"
                    defaultMessage="Key Travel Help Center"
                  />
                )
            }
          </a>
          <a href={`${helpCenterUrl}/requests/new`}
            className="dropdown-item my-2"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FormattedMessage
              id="topNavBar.submitHelpRequest"
              defaultMessage="Submit help request"
            />
          </a>
        </div>
      </li>
    );
  }

  loggedInMenu() {
    const { user } = this.props;

    return (
      <ul className="nav navbar-nav ml-auto loggedin-menu">
        {this.helpMenu}
        <li className="nav-item dropdown">
          <button
            type="button"
            className="btn btn-link nav-link dropdown-toggle"
            data-toggle="dropdown"
          >
            {user.staffId ? 'Impersonating: ' : ''}
            {user.fullName}
          </button>
          <div className="dropdown-menu dropdown-menu-right">
            <Link className="dropdown-item" to="/my-groups">
              <FormattedMessage
                id="topNavBar.loggedInMenu.myGroups"
                defaultMessage="My Groups"
              />
            </Link>
            <Link className="dropdown-item" to="/account">
              <FormattedMessage
                id="topNavBar.loggedInMenu.myAccount"
                defaultMessage="My account"
              />
            </Link>
            <div className="dropdown-divider" />
            <a className="dropdown-item" href="/logout">
              <FormattedMessage
                id="topNavBar.loggedInMenu.logout"
                defaultMessage="Log out"
              />
            </a>
          </div>
        </li>
      </ul>
    );
  }

  guestMenu() {
    return (
      <ul className="nav navbar-nav ml-auto guest-menu">
        {this.helpMenu}
        <li className="nav-item">
          <a
            href="#signin"
            className="btn btn-link nav-link login-link"
            onClick={this.onLoginClick}
          >
            <FormattedMessage
              id="topNavBar.guestMenu.login"
              defaultMessage="Login"
            />
          </a>
        </li>
      </ul>
    );
  }

  renderBrandLogo() {
    const imageSource = get(this.props, 'merchant.logoUrl') || pbgLogoBlue;
    const imageClassName = !get(this.props, 'merchant.logoUrl') && 'pbg-logo';
    const imageAlt = get(this.props, 'merchant.displayName', 'Key Travel');
    return <img src={imageSource} alt={imageAlt} className={`brand-logo ${imageClassName}`} />;
  }

  render() {
    return (
      <nav className="navbar top-nav-bar navbar-light navbar-toggleable-sm navbar-fixed-top">
        <div className="container">
          <div className="navbar-header">
            <button
              className="navbar-toggler navbar-toggler-right"
              type="button"
              data-toggle="collapse"
              data-target="#top-nav-user"
            >
              <span className="navbar-toggler-icon" />
            </button>
            {this.renderBrandLogo()}
          </div>
          <div id="top-nav-user" className="navbar-collapse collapse">
            {this.props.user ? this.loggedInMenu() : this.guestMenu()}
          </div>
        </div>
      </nav>
    );
  }
}

export default TopNavBar;



// WEBPACK FOOTER //
// ./src/desktop/components/top-nav-bar.js